var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Input',{attrs:{"search":"","placeholder":"职务名称搜索"}}),_c('u-tree',{ref:"tree",attrs:{"data":_vm.list,"multiple":_vm.multiple},on:{"on-change":_vm.onTreeChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }